import { React } from "react";
import Navbar from "../layout/Navbar";
import './News.css';
import { Link } from 'react-router-dom';

const News = () => {
    return (
        <div className="Contaainer">
            <Navbar />
            <div>
                <br></br>
                    <Link to="/addnew">
                        <button type="button" class="btn btn-primary">+ Add News</button>
                    </Link>  
                <br></br>
                <br></br>
                <table class="table">
                    <thead>
                    <tr>
                            <th>#</th>
                            <th>News</th>
                            <th>Short Detail</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>1</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>2</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>3</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>4</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>5</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>6</td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default News;